import type { IElementPromoCodeModalComponent } from '@belong/types';
import { FImage } from '../image.factory';
import { structureResponse } from '../structureResponse';

export const FElementPromoCodeModalComponent = (data: any): IElementPromoCodeModalComponent => {
  const { sys, fields } = structureResponse(data);
  const { promoCodeModalImage, ...otherFields } = fields;
  return {
    identifier: sys.id,
    contentType: 'elementPromoCodeComponent',
    promoCodeModalImage: FImage(promoCodeModalImage),
    ...otherFields
  };
};
